<template>
  <div class="change-to-layout" v-if="isShow">
    <div>
      <img @click="toMy" class="to-buy" src="https://charter.huolala.cn/h5/cdn/img/202003/V1/buy.png" alt="">
      <img @click="toShortRent" class="to-rent" src="https://charter.huolala.cn/h5/cdn/img/202003/V1/rent.png" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        isShow: true
      }
    },
    methods: {
      toMy () {
        this.isShow = false
        this.$emit('recordClick', '去买车')
      },
      toShortRent () {
        this.$emit('recordClick', '去短租')
        window.location.href = 'https://charter.huolala.cn/h5/short-rent/index.html#/'
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "~@/assets/css/rpx.scss";
.change-to-layout{
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(0,0,0,0.8);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  div{
    height: rpx(330);
    padding: 0 rpx(30);
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 47%;
      margin: 0 rpx(10);
    }
  }
}
</style>